import * as React from 'react';
export const SvgPanoramaModel = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', fill: 'var(--iui-color-icon-muted, currentColor)', ...props },
        React.createElement("path", { d: 'M8 5.48L3.14 7.53v6.14L8.02 16l4.83-2.47v-6zm-.25 9.61l-3.86-1.91V8.25l3.86 1.64zM4.26 7.86L8 6.3l3.78 1.59-.05.02-3.71 1.56zm7.84 5.22l-3.82 2.01V9.9l3.82-1.61zM16 1v12l-2.15-.44v-1.02l1.14.24V2.22l-3 .6v3.26l-1-.42V3h-6L5 5.66l-1 .42-.01-3.26-3-.6v9.56l1.15-.24v1.02L0 13V1l4.99 1h6z' })));
};
export default SvgPanoramaModel;
